import { TextProps } from '../../atoms/Text';
import { ButtonProps } from '../../atoms/Button';
import { ImageProps } from '../../atoms/Image';


type GenericStateBlockInternalProps = {
  image?: ImageProps;
  topText?: TextProps;
  bottomText?: TextProps;
  button?: ButtonProps;
};

type GenericStateBlockPropsValues = {
  '': GenericStateBlockInternalProps;
};

const propValues: GenericStateBlockPropsValues = {
  '': {
    image: {
      type: 'Square',
    },
    topText: {
      style: 'Bold',
      align: 'Center',
      colour: 'Default',
      type: 'Heading3',
    },
    bottomText: {
      style: 'Regular',
      align: 'Center',
      colour: 'Default',
      type: 'Body1',
    },
    button: {
      style: 'Contained',
      size: 'Large',
      type: 'Text',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
  },
};

const getProps = (type: string): GenericStateBlockInternalProps => {
  const values: GenericStateBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
